var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import Text from './Text';
export default function SemiTitle(_a) {
    var { children } = _a, rest = __rest(_a, ["children"]);
    if (!children)
        return null;
    return (jsx(Text, Object.assign({ variant: "semiTitle", sx: { paddingTop: 3, paddingBottom: 2 } }, rest), children));
}
//# sourceMappingURL=SemiTitle.js.map